import Input from './Input';
import Group from './Group';
import Search from './Search';
import TextArea from './TextArea';
import Password from './Password';
Input.Group = Group;
Input.Search = Search;
Input.TextArea = TextArea;
Input.Password = Password;
export default Input;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/input/index.js
// module id = 100
// module chunks = 0